import React from 'react';

// mui
import { Button, styled, Tooltip } from '@mui/material';

// icons
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';

const UndoButton = styled(Button)({
  textTransform: 'unset !important',
  color: 'var(--color-text-primary)',
  border: '1px solid transparent',
  '&:hover': {
    color: 'var(--color-error)',
    border: '1px solid var(--color-error)',
    background: 'var(--color-bg-paper)',
  },
});

function DiscardChangesButton({ disabled, onDiscard }) {
  const handleClick = () => {
    if (onDiscard) {
      onDiscard();
    } else {
      window.location.reload();
    }
  };

  return (
    <Tooltip title="Undo all changes since last save" placement="bottom">
      <span>
        <UndoButton
          size={'small'}
          startIcon={<UndoOutlinedIcon />}
          disabled={disabled}
          onClick={handleClick}
        >
          Undo
        </UndoButton>
      </span>
    </Tooltip>
  );
}

export default DiscardChangesButton;
